// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfService_root__YB9-b","lastUpdated":"TermsOfService_lastUpdated__13BAl","anchor":"TermsOfService_anchor__32rpY","bold":"TermsOfService_bold__2DCeS"};